<template>
  <div :class="{ parent: data.parent === 0 }" class='UserPermissionList'>
    <div><input @change="e => ChangeUserPermission(data)" type="checkbox" :checked="data.active"></div>
    <div>{{ data.name === 'Produtos' && Empresa.modelo === 'Modelo 03' ? 'Captações' : data.name }}</div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'UserPermissionList',
  props: ['data'],
  computed: {
    ...mapGetters(['Empresa'])
  },
  methods: {
    ...mapActions(['ChangeUserPermission'])
  }
}
</script>

<style scoped>
.UserPermissionList {
  display: flex;
  align-items: center;
  padding: 1%;
}

.nivel1 {
  padding-left: 3%;
}

.parent {
  font-weight: bold;
  background-color: #EEEEEE;
  border-bottom: thin solid #CCCCCC;
}
</style>
